import { AnimatePresence, motion } from 'framer-motion'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const animations = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
}

const PageTransition = ({ children }) => {
  const [transitioning, setTransitioning] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setTransitioning(true)
    setTimeout(() => {
      setTransitioning(false)
    }, 1000)
  }, [location])

  return (
    <>
      <AnimatePresence mode="wait">
        {transitioning && (
          <motion.div
            key="pageTransition"
            variants={animations}
            initial="initial"
            animate="animate"
            exit="exit"
            className="h-full w-full bg-primary absolute left-0 top-0 z-40"
            transition={{ duration: 0.5 }}
          >
            <div className="page-transition"></div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence mode="wait">
        {!transitioning && (
          <motion.div
            key="routeChildren"
            variants={animations}
            initial="initial"
            animate="animate"
            exit="exit"
            className="z-1"
            transition={{ duration: 0.5 }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

PageTransition.propTypes = {
  children: PropTypes.any,
}

export default PageTransition
